import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { globals } from "../../globals";
import { NtfSumarioNotificacaoModel } from "../models/ntf-sumario-notificacao-model";

export interface SumarioNotificacaoResponse {
  result: NtfSumarioNotificacaoModel;
}

@Injectable({
  providedIn: "root",
})
export class NotificacaoServiceV2 {
  constructor(
    private http: HttpClient,
  ) { }

  buscarSumario(): Observable<SumarioNotificacaoResponse>{
    return this.http.get<SumarioNotificacaoResponse>(`${globals.apiUrl}/api/v2/account/notificacao/sumario`);
  }
}
